<div class="offer-link">
  <div class="offer-link__title">
      <p class="vox-heading-2" translate>marketing.offer-link.title</p>
  </div>
  <hr />
  <div class="offer-link__main">
    <div class="vox-inline-message vox-inline-message_light-grey">
      <div>
        <i class="icon-small-info"></i>
        <span>
          <div translate>marketing.offer-link.disclaimer.how</div>
          <ul>
            <li translate>marketing.offer-link.disclaimer.1</li>
            <li translate>marketing.offer-link.disclaimer.2</li>
            <li translate>marketing.offer-link.disclaimer.3
              <button class="vox-btn link-btn" type="button" (click)="openAddMetadataPopup()"
              translate>marketing.offer-link.disclaimer.link</button>
            </li>
            <li translate>marketing.offer-link.disclaimer.4</li>
            <li translate>marketing.offer-link.disclaimer.5</li>
          </ul>
        </span>
      </div>
    </div>
    <gdp-coupon-metadata-form (emitValue)="generateMetadata($event)"></gdp-coupon-metadata-form>
    <gdp-generate-link-form (emitValue)="generateLink($event)"></gdp-generate-link-form>
  </div>
</div>

<ng-template #couponMetadataPopup let-modal>
  <gdp-copy-feedback-popup
    [title]="'marketing.offer-link.metadata-form.feedback-title' | translate"
    [feedback]="'marketing.offer-link.metadata-form.link-copied' | translate"
    [content]="modalValues.content">
    <div class="value-container vox-card"><pre [innerHTML]="modalValues.content | prettyprint"></pre></div>
    <div>
      <button class="vox-btn link-btn" type="button"
      [ngbPopover]="popTemplate" triggers="mouseenter:mouseleave" placement="top"
      triggers="focus" #p="ngbPopover" (click)="p.open();" autoClose="outside"
      translate>marketing.offer-link.disclaimer.link
      <i class="icon-small-help"></i>
      </button>
    </div>
  </gdp-copy-feedback-popup>
</ng-template>

<ng-template #popTemplate let-greeting="greeting">
  <img src="assets/img/how-to-add-metadata-to-coupon.png" alt="How" width="525px"
  height="700px">
</ng-template>

<ng-template #offerLinkPopup let-modal>
  <gdp-copy-feedback-popup
    [title]="'marketing.offer-link.generate-link-form.feedback-title' | translate"
    [feedback]="'marketing.offer-link.generate-link-form.link-copied' | translate"
    [content]="modalValues.content">
    <div class="link-container">
      <a [href]="modalValues.content" target="_blank" class="link">{{modalValues.content}}</a>
    </div>
  </gdp-copy-feedback-popup>
</ng-template>